import { render, staticRenderFns } from "./Pointe.vue?vue&type=template&id=46bfc274&scoped=true"
import script from "./Pointe.vue?vue&type=script&lang=js"
export * from "./Pointe.vue?vue&type=script&lang=js"
import style0 from "./Pointe.vue?vue&type=style&index=0&id=46bfc274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bfc274",
  null
  
)

export default component.exports